const apiUrl = '/fa/rest';
const authUrl = '/authenticate';
const authCheckUrl = '/fa/rest/authCheck';
const getHost = () =>
  window.location.hostname === 'localhost' ? 'http://secretar' : '';

export const ROLE_ADMIN = 'administrator';
export const ROLE_COMPANY_ADMIN = 'company_admin';
export const ROLE_COMPANY_MANAGER = 'company_manager';
export const ROLE_CALLCENTER_ADMIN = 'callcenter_admin';
export const ROLE_CALLCENTER_MANAGER = 'callcenter_manager';
export const ROLE_QCD_ADMIN = 'qcd_admin';

export { apiUrl, authUrl, getHost, authCheckUrl };



// WEBPACK FOOTER //
// ./src/config.js